<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="formData.benefit.action && formData.benefit.action !== formLabels.fields.benefitAction2">
            <div class="col-12 col-lg-4">
                <div :class="['form-field',{'form-field--error':$v.formData.benefit.fromStation.$error}]">
                    <label for="fromStation">{{ formLabels.fields.fromStation }}</label>
                    <input v-model="formData.benefit.fromStation" id="fromStation" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.fromStation" v-tooltip="formTooltips.benefit.fields.fromStation">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.fromStation.$error">This field is required</span>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div :class="['form-field',{'form-field--error':$v.formData.benefit.toStation.$error}]">
                    <label for="toStation">{{ formLabels.fields.toStation }}</label>
                    <input v-model="formData.benefit.toStation" id="toStation" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.toStation" v-tooltip="formTooltips.benefit.fields.toStation">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.toStation.$error">This field is required</span>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div :class="['form-field',{'form-field--error':$v.formData.benefit.photocardNum.$error}]">
                    <label for="photocardNum">{{ formLabels.fields.photocardNum }}</label>
                    <input v-model="formData.benefit.photocardNum" id="photocardNum" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.photocardNum" v-tooltip="formTooltips.benefit.fields.photocardNum">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.photocardNum.$error">This field is required</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object,
        }
    },
    inject: ['$v'],
    watch: {
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.benefit.action': {
            handler: function(newVal) {
                this.formData.benefit.toStation = undefined;
                this.formData.benefit.fromStation = undefined;
                this.formData.benefit.photocardNum = undefined;
            }
        }
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    methods: {
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.fromStation = function() { return this.formData.benefit.action && this.formData.benefit.action !== this.formLabels.benefit.fields.benefitAction2 };
            this.formConditionals.toStation = function() { return this.formData.benefit.action && this.formData.benefit.action !== this.formLabels.benefit.fields.benefitAction2 };
            this.formConditionals.photocardNum = function() { return this.formData.benefit.action && this.formData.benefit.action !== this.formLabels.benefit.fields.benefitAction2 };
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    fromStation: 'From station',
                    toStation: 'To station',
                    photocardNum: 'Photocard number',
                    action: 'Ticket action'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        },
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {}
        });
    }
}
</script>